<div class="combined-service-tile card card--flex">
  <header class="combined-service-tile__header">
    <h3 class="combined-service-tile__title">{{ "Overview.CombinedServiceTile.Title" | translate }}</h3>
    <p class="combined-service-tile__description">{{ servicesCount() }} services</p>
  </header>

  <div class="combined-service-tile__content">
    <ul class="combined-service-tile__list">
      @for (subscription of subscriptions() | keyvalue; track $index) {
        <li class="combined-service-tile__list-item">
          @let destination = subscriptionRoutes()[subscription.key];
          @if (destination.indexOf("https://") < 0) {
            <a
              class="combined-service-tile__list-item-inner"
              [class.no-subscriptions]="!subscription.value.subscriptions"
              [routerLink]="destination"
            >
              <ng-container [ngTemplateOutlet]="tileContent"></ng-container>
            </a>
          } @else {
            <a
              class="combined-service-tile__list-item-inner"
              [class.no-subscriptions]="!subscription.value.subscriptions"
              [href]="destination"
              target="_blank"
            >
              <ng-container [ngTemplateOutlet]="tileContent"></ng-container>
            </a>
          }

          <ng-template #tileContent>
            <span class="service-tile__icon-container service-tile__{{ subscription.key | lowercase }}">
              <svg-icon
                src="assets/images/icons/{{ subscription.key | lowercase }}.svg"
                class="service-tile__icon"
              ></svg-icon>
              @if ((subscription.value.firewallsEnabled ?? 0) > 0) {
                <span class="service-tile__overlap">
                  <span class="service-tile__overlap-square">
                    <div class="service-tile__overlap-tooltip">
                      {{ subscription.value.firewallsEnabled }} {{ "Subscription.FW.Tooltip" | translate }}
                    </div>
                    <svg-icon src="assets/images/icons/fw-overlap.svg" class="service-tile__overlap-icon"></svg-icon>
                  </span>
                </span>
              }
            </span>
            <div>
              <h3>{{ tileNameKey(subscription.key) | translate }}</h3>
              @if (subscription.value.subscriptions; as count) {
                <div>{{ "Overview.Services" | translate: { count: count } }}</div>
              }
              @if (subscription.value.available) {
                <div class="blue">{{ "Global.MoreInfo" | translate }}</div>
              } @else if (!subscription.value.subscriptions) {
                <div class="combined-service-tile__loader"></div>
              }
            </div>
          </ng-template>
        </li>
      }
    </ul>
  </div>

  <div class="combined-service-tile__footer">
    <div class="combined-service-tile__health-indicators" [class.no-services]="noServices()">
      <div class="combined-service-tile__health-indicators-item">
        <svg-icon
          src="assets/images/icons/{{ 'status-ok' }}.svg"
          matTooltip="{{ 'Services.Status.Ok' | translate }}"
          [matTooltipPosition]="'above'"
        >
        </svg-icon>
        <span>{{ okCounts() }}</span>
      </div>
      <div class="combined-service-tile__health-indicators-item">
        <svg-icon
          src="assets/images/icons/{{ 'status-no-traffic' }}.svg"
          matTooltip="{{ 'Services.Status.NoTraffic' | translate }}"
          [matTooltipPosition]="'above'"
        >
        </svg-icon>
        <span>{{ notrafficCounts() }}</span>
      </div>
      <div class="combined-service-tile__health-indicators-item">
        <svg-icon
          src="assets/images/icons/{{ 'status-warning' }}.svg"
          matTooltip="{{ 'Services.Status.Warning' | translate }}"
          [matTooltipPosition]="'above'"
        >
        </svg-icon>
        <span>{{ malfunctionCounts() }}</span>
      </div>
    </div>
  </div>
</div>
